import { cva } from 'class-variance-authority'

export const DescriptionStyles = cva([], { variants: {} })
